import Vue from 'vue'
import VueI18n from 'vue-i18n'

// 导入语言文件
import enMessages from './en.json'
import zhMessages from './zh.json'

Vue.use(VueI18n)

// 创建 i18n 实例
const i18n = new VueI18n({
  locale: 'zh', // 默认语言
  fallbackLocale: 'en', // 备用语言
  messages: {
    en: enMessages,
    zh: zhMessages
  },
  silentTranslationWarn: true // 静默翻译警告
})

// 语言切换函数
export function setLocale(lang) {
  i18n.locale = lang
  localStorage.setItem('locale', lang)
}

// 获取当前语言
export function getLocale() {
  return i18n.locale
}

// 获取支持的语言列表
export function getSupportedLocales() {
  return [
    { code: 'en', name: 'English', flag: '🇺🇸' },
    { code: 'zh', name: '中文', flag: '🇨🇳' }
  ]
}

// 初始化语言设置
export function initLocale() {
  const savedLocale = localStorage.getItem('locale')
  if (savedLocale && (savedLocale === 'en' || savedLocale === 'zh')) {
    i18n.locale = savedLocale
  } else {
    // 检测浏览器语言
    const browserLang = navigator.language || navigator.userLanguage
    if (browserLang.startsWith('zh')) {
      i18n.locale = 'zh'
    } else {
      i18n.locale = 'en'
    }
    localStorage.setItem('locale', i18n.locale)
  }
}

export default i18n